<template>
  <div class="component_1">
    <v-row>
      <v-col cols="12" class="ma-0">
        <v-data-table
          :headers="$getHeaderType2(headerTxt, headerEn, headerAr)"
          :items="paymentList"
          hide-default-footer
          :items-per-page="totalCount"
          disable-sort
          class="new__type__table empty__td"
          @click:row="fnGetReceipt"
        >
          <template v-slot:item.payment_item_seq="{ item }">
            <div style="text-align:center" v-if="paid !== 'Y'">
              <v-checkbox v-model="selected" :value="item.payment_item_seq" :disabled="true"></v-checkbox>
            </div>
          </template>
          <template v-slot:item.fee_config_name_ar="{ item }">
            <div class="text-right">{{ item.fee_config_name_ar }}</div>
          </template>
          <template v-slot:item.fee_config_name_en="{ item }">
            <div class="text-left">{{ item.fee_config_name_en }}</div>
          </template>
          <template v-slot:item.total_amount="{ item }">
            {{ item.total_amount | comma }}
          </template>
        </v-data-table>
        <v-row class="ma-0 mt-15">
          <v-col class="pa-0 d-flex" cols="12">
            <v-spacer class="d-inline-flex"></v-spacer>
            <v-btn
              color="#007aff"
              dark
              min-width="150"
              min-height="50"
              class="btn-normal br_none"
              @click="fnShowInvoice"
              v-if="paid === 'N'"
            >
              {{ $t('component.payment.fields.view_invoice') }}
            </v-btn>
          </v-col>
        </v-row>

        <DialogInvoice
          :prop_dialog_invoice.sync="dialog_invoice"
          :prop_invoiceList.sync="invoiceList"
          :receipt_no.sync="receipt_no"
          :query.sync="query"
          @close="fnCloseDialogInvoice"
          @error="fnSetDialog">
        </DialogInvoice>
        <DialogReceipt
          :prop_dialog_receipt.sync="dialog_receipt"
          :prop_receipt.sync="receipt"
          @close="fnCloseDialogReceipt">
        </DialogReceipt>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import store from '@/store'
import DialogInvoice from '@/components/layout/DialogInvoice'
import DialogReceipt from '@/components/layout/DialogReceipt'

export default {
  name: 'Payment',
  props : {
    payments: {
      type: Array
    },
    receipt_no: {
      type: String
    },
    payment_history_seq: {
      type: Number
    },
    query: {
      type: Object
    },
    paid: {
      type: String,
      default: 'N'
    }
  },
  components: {
    DialogInvoice,
    DialogReceipt,
  },
  computed: {
    totalAmount() {
      let amount = 0
      this.invoiceList.forEach(item => {
        amount += item.total_amount
      })
      return amount * 100
    },
    paymentList() {
      let payments = []

      this.payments.forEach(item => {
        if (this.paid === 'Y') {
          if (item.ind_paid === 'Y') {
            payments.push(item)
          }
        } else {
          payments.push(item)
        }
      })

      return payments
    }
  },
  watch: {
    payments(val) {
      this.totalCount = val.length

      this.selected = []
      val.forEach(item => {
        if (utils.isNull(item.paid_date)) {
          this.selected.push(item.payment_item_seq)
        }
      })
    }
  },
  filters:{
    comma(val){
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  data () {
    return {
      id: 'CommonPayment',
      headerTxt : {
        prefix : 'component.payment.fields.',
        txt : [ '', 'fee', 'due_date', 'amount', 'paid_date','applicant_type' ]
      },

      headerAr: [
        { text: '', align: (this.paid === 'Y' ? ' d-none':'center'), value: 'payment_item_seq', width: '50' },
        { text: 'Fee', align: 'center', value: 'fee_config_name_ar' },
        { text: 'Due Date', align: (this.paid === 'Y' ? ' d-none':'center'), value: 'due_date', width: '100' },
        { text: 'Amount', align: (this.paid === 'N' ? ' d-none':'center'), value: 'total_amount', width: '100' },
        { text: 'Paid Date', align: 'center', value: 'paid_date', width: '100' },
        { text: 'Applicant Type',  align: 'center', value: 'applicant_type_name_ar', width: '100' }
      ],
      headerEn: [
        { text: '', align: (this.paid === 'Y' ? ' d-none':'center'), value: 'payment_item_seq', width: '50' },
        { text: 'Fee', align: 'center', value: 'fee_config_name_en' },
        { text: 'Due Date', align: (this.paid === 'Y' ? ' d-none':'center'), value: 'due_date', width: '100' },
        { text: 'Amount', align: (this.paid === 'N' ? ' d-none':'center'), value: 'total_amount', width: '100' },
        { text: 'Paid Date', align: 'center', value: 'paid_date', width: '100' },
        { text: 'Applicant Type',  align: 'center', value: 'applicant_type_name_en', width: '100' }
      ],
      totalCount: 0,

      selected: [],

      dialog_invoice: false,
      dialog_receipt: false,

      invoiceList: [],
      receiptList: [],

      invoiceHeaderAr: [
        { text: '#', align: 'center', value: 'no', width: '50px', class: 'data_table_header'},
        { text: 'Descriptions', align: 'center', value: 'name_ar', width: '50%', class: 'data_table_header' },
        { text: 'Invoice Date', align: 'center', value: 'issued_date', class: 'data_table_header'},
        { text: 'Qty', align: 'center', value: 'qty', class: 'data_table_header'},
        { text: 'Rate', align: 'center', value: 'amount', class: 'data_table_header'},
        { text: 'Late Charge', align: 'center', value: 'late_charge_amount', class: 'data_table_header'},
        { text: 'Amount', align: 'center', value: 'total_amount', class: 'data_table_header'}
      ],

      invoiceHeaderEn: [
        { text: '#', align: 'center', value: 'no', width: '50px', class: 'data_table_header'},
        { text: 'Descriptions', align: 'center', value: 'name_en', width: '50%', class: 'data_table_header'},
        { text: 'Invoice Date', align: 'center', value: 'issued_date', class: 'data_table_header'},
        { text: 'Qty', align: 'center', value: 'qty', class: 'data_table_header'},
        { text: 'Rate', align: 'center', value: 'amount', class: 'data_table_header'},
        { text: 'Late Charge', align: 'center', value: 'late_charge_amount', class: 'data_table_header'},
        { text: 'Amount', align: 'center', value: 'total_amount', class: 'data_table_header'}
      ],

      receiptHeader: [
      ],

      payment: {
        access_code: process.env.VUE_APP_ACCESS_CODE,
        merchant_name: process.env.VUE_APP_MERCHANT_NAME,
        merchant_id: process.env.VUE_APP_MERCHANT_ID,
        payment_url: process.env.VUE_APP_PAYMENT_URL,
        return_url: '',
        version: '1',
        command: 'pay',
        currency: 'EGP',
        locale: 'en',
        secureHash: '',
        transaction_id: null
      },

      result: {
        message: '',
        transactionNo: null,
        txnResponseCode: null
      },

      receipt: {},
    }
  },
  mounted() {
    this.totalCount = this.payments.length
    this.selected = []
    this.payments.forEach(item => {
      if (utils.isNull(item.due_date) && utils.isNull(item.paid_date)) {
        this.selected.push(item.payment_item_seq)
      }
    })
  },
  methods: {
    fnShowInvoice() {
      if (this.selected.length === 0) {
        let options = {
          text: this.$t('common.message.no_selected_data')
        }
        eventBus.$emit('SHOW_SNACKBAR', options)
        return
      }

      let params = ''
      this.selected.forEach((item, index) => {
        if (index === 0) {
          params += '?seqs='+ item
        } else {
          params += '&seqs='+ item
        }
      })
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/invoices'+ params,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.invoiceList = res.data.list
            this.dialog_invoice = true
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnShowInvoice()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnPay() {
      let seqs = []
      this.selected.forEach(item => {
       seqs.push(item)
      })
      let params = {
        payment_item_seq: seqs
      }
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/payment',
        method: 'POST',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.payment.transaction_id = res.data.payment_history_seq
            let href = document.location.href
            if (href.indexOf('?') > -1) {
              let hrefs = href.split('?')[0].split('/')
              this.payment.return_url = hrefs.splice(0, hrefs.length - 1).join('/') +'/'+ this.payment.transaction_id
            } else {
              this.payment.return_url = document.location.href +'/'+ this.payment.transaction_id
            }
            this.fnGetSecureHash()
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnPay()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetSecureHash() {
      store.dispatch('RequestApi')

      let params = {
        vpc_AccessCode: this.payment.access_code,
        vpc_Amount: this.totalAmount,
        vpc_Command: this.payment.command,
        vpc_Currency: this.payment.currency,
        vpc_Locale: this.payment.locale,
        vpc_MerchTxnRef: this.payment.transaction_id,
        vpc_Merchant: this.payment.merchant_id,
        vpc_OrderInfo: this.payment.transaction_id,
        vpc_ReturnURL: this.payment.return_url,
        vpc_Version: this.payment.version
      }
      requestApi({
        url: '/autho/hmac',
        method: 'POST',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.payment.secureHash = res.data.enc
            document.frmPayment.vpc_SecureHash.value = this.payment.secureHash
            document.frmPayment.submit()
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetSecureHash()
              })
            } else {
              store.dispatch('SetInitRequestApi')
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },



    fnGetReceipt(item) {
      if (!item.payment_history_seq || !item.payment_item_seq) {
        this.$router.replace('/payment/list?search_receipt_no='+ this.receipt_no)
        return
      }

      this.receipt = {}
      let params = {
        payment_history_seq: item.payment_history_seq,
        payment_item_seq: item.payment_item_seq
      }
      requestApi({
         url: '/receivings/'+ this.receipt_no +'/receipt',
        method: 'GET',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.receipt = res.data
            this.dialog_receipt = true
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt(item)
              })
            } else {
              store.dispatch('SetInitRequestApi')
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCloseDialogInvoice() {
      this.dialog_invoice = false;
    },

    fnCloseDialogReceipt() {
      this.dialog_receipt = false;
    },

    fnSetDialog(option) {
      this.$router.push(option.path)
      eventBus.$emit('SHOW_DIALOG', option)
    }
  }
}
</script>

<style>
.data_table_header {
	border-bottom: 1px solid #222222 !important;
	text-align: left;
	background: #444;
	color: #fff !important;
	padding: 0 5px;
	height: 48px;
}
</style>